import { createFileRoute } from '@tanstack/react-router';
import { FrontDoorCapture } from '../../components/admin/FrontDoorCapture';

export const Route = createFileRoute('/admin/front-door')({
  component: FrontDoorCapture,
});
